import jqueryModule from 'jquery'

const $ = window.$ || jqueryModule?.default || jqueryModule

globalThis.$ = $
globalThis.jQuery = $
window.$ = $
window.jQuery = $

export default $
